import { type DatabaseJSON } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';

export function getEntriesCount(database: DatabaseJSON): number {
  return database.entries.length;
}

export function getFieldsCount(database: DatabaseJSON): number {
  return database.fields.length;
}

export function getViewsCount(database: DatabaseJSON): number {
  return database.views.length;
}

export function getFieldTypeCounts(database: DatabaseJSON): Record<FieldType, number> {
  const fieldTypeCounts = new Map<FieldType, number>();

  Object.keys(database.fieldsById).forEach((id) => {
    const type = database.fieldsById[id].type;

    if (fieldTypeCounts.has(type)) {
      fieldTypeCounts.set(type, (fieldTypeCounts.get(type) ?? 0) + 1);
    } else {
      fieldTypeCounts.set(type, 1);
    }
  });

  return Object.fromEntries(fieldTypeCounts) as Record<FieldType, number>;
}

export function getFieldTypes(database: DatabaseJSON): FieldType[] {
  return Array.from(new Set(Object.keys(getFieldTypeCounts(database)))) as FieldType[];
}
